module.exports = __webpack_public_path__ + "static/Beholder_kin_2-01672ec629c65c09ad2e40787c398078.jpg";